import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom arrow components
const PrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button
      className="absolute -left-12 top-1/2 z-10 p-4 text-gray-700 rounded-full shadow-lg transition-all duration-200 transform -translate-y-1/2 bg-white/90 hover:bg-white hover:text-gray-900 hover:scale-110"
      onClick={onClick}
      type="button"
      aria-label="Previous slide"
    >
      <svg
        className="w-8 h-8"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
  );
};

const NextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button
      className="absolute -right-12 top-1/2 z-10 p-4 text-gray-700 rounded-full shadow-lg transition-all duration-200 transform -translate-y-1/2 bg-white/90 hover:bg-white hover:text-gray-900 hover:scale-110"
      onClick={onClick}
      type="button"
      aria-label="Next slide"
    >
      <svg
        className="w-8 h-8"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  );
};

const Equipment: React.FC = () => {
  const equipmentItems = [
    {
      name: "16 presse meccaniche e idrauliche",
      description:
        "Pensate per rispondere a ogni esigenza di stampaggio, con una potenza che varia da 80 a 500 tonnellate, garantendo la massima versatilità e precisione su una vasta gamma di materiali e spessori. le nostre macchine sono dotate di svolgitori automatici, che ne ottimizzano il funzionamento e assicurano una produzione costante ed efficiente, mantenendo standard di qualità elevatissimi.",
      media: "/equipment/pressa-500t.jpeg",
      type: "image",
    },

    /*
    {
     name: "Pressa 300T Rovetta",
      description:
        "Pressa meccanica Rovetta da 300 tonnellate, un classico dell'industria dello stampaggio, nota per la sua longevità. Alimentata elettricamente, continua a essere una scelta affidabile.",
      media: "/equipment/rovetta-500t.jpg",
      type: "image",
    },*/
    {
      name: "9 Puntatrici Tecna per saldature a punti e proiezione",
      description:
        "Puntatrici Tecna da 30 a 160kW dotate di Controllo GEM. Spara boccole GEM con lancia. Perni di centraggio in ceramica fatti su misura ci permettono di effettuare saldature precise e di alta qualità, Perfette per produzioni che richiedono precisione e ripetibilità",
      media: "/equipment/saldatrice120.jpg",
      type: "image",
    },
    {
      name: "Isole robotizzate di saltatura MIG/MAG",
      description:
        "Impianto di saldatura automatizzato con robot KAWASAKI, tecnologia MIG/MAG. Questa isola robotizzata permette di eseguire saldature complesse con altissima precisione, ripetibilità e velocità, garantendo giunzioni di qualità superiore e una produzione ottimizzata.",
      media: "/equipment/isola-saldatura.jpg",
      type: "image",
    },
    {
      name: "Stampi prodotti internamente",
      description:
        "Creiamo internamente i nostri stampi, questo ci permette di intervenire in modo rapido ed efficiente per manutenzioni e modifiche, garantendo flessibilità e controllo totale sulla produzione. Tutto ciò è possibile grazie alla ELPA Solutions, azienda appositamente creata, con riconosciute capacità nella creazione di Stampi a passo, a blocco e attrezzature.",
      media: "/equipment/stampo.jpeg",
      type: "image",
    },
    {
      name: "Controllo Qualità",
      description:
        "Il nostro reparto qualità è all'avanguardia e si avvale di strumentazione di ultima generazione. Con una macchina di misura a coordinate (CMM) DEA SCIROCCO per il controllo dimensionale e uno scanner laser 3D LEONARDO per ispezioni complesse garantiamo controlli rapidi e con l'ausilio di software di metrologia 3D come POLYWORKS che ci permette di eseguire controlli scrupolosi.",
      media: "/equipment/qqctrl.jpg",
      type: "image",
    },
    {
      name: "Reparto Realizzazione Attrezzature e Prototipia",
      description:
        "La nostra officine può contare su 4 Centri di fresatura a controllo numerico (CNC), macchine ad alte prestazioni per lavorazioni di precisione su stampi e componenti meccanici complessi che permettono finiture di alta qualità e massima efficienza produttiva.",
      media: "/equipment/cnc-milling.jpg",
      type: "image",
    },
    {
      name: "ELETTROROSIONE - EDM Agie Charmilles ",
      description:
        "La AgieCharmilles CUT 30 è il perfetto equilibrio tra produttività e precisione. È estremamente accurata e flessibile ed è in grado di fornire soluzioni complete e integrate alle tue sfide produttive. Preparati ad ottenere risultati di una qualità senza compromessi nell’ambito dell’accuratezza o della finitura di superficie per raggiungere la più alta qualità del prodotto e ottimizzare la produttività.",
      media: "/equipment/EDM.png",
      type: "image",
    },
    {
      name: "Laser Optimo Prima Industrie 3D",
      description:
        "macchina taglio laser Optimo Prima Industrie 3D nel nostro stabilimento ci permette di ottenere tagli di altissima qualità e di una precisione eccezionale su tre dimensioni. Questo macchinario è fondamentale per le nostre lavorazioni più complesse.",
      media: "/equipment/laser.png",
      type: "image",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="py-12 bg-gray-50">
      <div className="container px-4 mx-auto sm:px-6 lg:px-8">
        <div className="mb-6 text-center">
          <h2 className="text-3xl font-bold text-gray-800">
            CO.ME.ST: la nostra forza al vostro servizio
          </h2>
          <p className="text-gray-600">
            Presse, saldatrici, robot ed infrastrutture per servire al meglio i
            nostri clienti
          </p>
        </div>
        <div className="relative">
          <Slider {...settings}>
            {equipmentItems.map((item) => (
              <div key={item.name} className="p-2">
                <div className="flex overflow-hidden flex-col h-full bg-white rounded-lg shadow-md">
                  <div className="relative pt-[100%]">
                    {" "}
                    {/* 1:1 aspect ratio */}
                    {item.type === "image" ? (
                      <img
                        src={item.media}
                        alt={item.name}
                        className="object-cover absolute top-0 left-0 w-full h-full"
                      />
                    ) : (
                      <video
                        src={item.media}
                        className="absolute top-0 left-0 w-full h-full"
                        autoPlay
                        loop
                        muted
                        playsInline
                      />
                    )}
                  </div>
                  <div className="flex flex-col flex-grow p-4">
                    <h3 className="font-semibold text-gray-800 text-lg line-clamp-2 min-h-[rem] text-center">
                      {item.name}
                    </h3>
                    <p className="text-gray-600 text-sm mt-2 line-clamp-7 min-h-[6.25rem]">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Equipment;
